export class NumberOfCopiesRule {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "minCopies",
            "baseName": "minCopies",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NumberOfCopiesRule.attributeTypeMap;
    }
    constructor() {
    }
}
